<template>
    <div class="footer">
        <div class="footer-main">
            <div class="footer-main-left">
                <h6>关于我们</h6>
                <!-- :href="item.goto" -->
                <a class="about-us" v-for="(item, index) in aboutUs" :key="index" target="_bank"  @click="goto(item.goto)">
                    {{item.name}}
                </a>
            </div>
            <div class="footer-main-middle">
                <h6>友情链接</h6>
                <a class="about-us" v-for="(item, index) in friendLink" :key="index" target="_bank" :href="item.linkurl">
                    {{item.title}}
                </a>
            </div>
            <div class="footer-main-right">
                <div class="phone-email">
                    <p>更多内容分享<br>扫描右侧二维码关注我们</p>
                    <a href="javascript:void(0)">
                        <svg-icon icon-class="phone"></svg-icon>
                        <span>{{tel}}</span>
                    </a>
                    <a :href="'mailto:'+email+'?subject=极之美&cc='+email">
                        <svg-icon icon-class="email"></svg-icon>
                        <span>{{email}}</span>
                    </a>
                </div>
                <div class="qr-code">
                    <ul>
                        <li v-for="(item, index) in qrCodes" :key="index">
                            <div class="code-box">
                              <img :src="item.path" alt="">
                            </div>
                            <p>{{item.name}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <p class="footer-address">{{address}}</p>
            <div class="footer-copyine">
              <p>{{copyine}}</p>
              <a class="copyine-link" href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_bank">京ICP备12040375号-3</a>
            </div>
        </div>
    </div>
</template>

<script>
import Code from '@/assets/img/code.png'
import {friendlink, baseset} from '@/api/header.js'
export default {
  data () {
    return {
      aboutUs: [
        {
          name: '公司简介',
          goto: '/about'
        },
        {
          name: '极之美NEWS',
          goto: '/news'
        },
        {
          name: '合作伙伴',
          goto: '/partners'
        },
        {
          name: '联系我们',
          goto: '/contactUs'
        }
      ],
      friendLink: [],
      qrCodes: [
        {
          name: '公众号',
          path: Code
        },
        {
          name: '小程序',
          path: Code
        },
        {
          name: '微博',
          path: Code
        }
      ],
      tel: '400-100-9884',
      email: 'lnfo@Tripolers.com',
      address: '地址：北京市朝阳区科荟路33号4幢',
      copyine: '版权所有 © 北京极之美旅行社有限公司'
    }
  },
  methods: {
    friendlink () {
      friendlink().then(res => {
        this.friendLink = res.data.data.items
      })
    },
    baseset () {
      baseset().then(res => {
        this.tel = res.data.data.mobilephone
        this.email = res.data.data.email
        this.qrCodes[0].path = res.data.data.gzhcode
        this.qrCodes[1].path = res.data.data.xcxcode
        this.qrCodes[2].path = res.data.data.wbcode
      })
    },
    goto (goto) {
      this.$router.push({path: goto})
    }
  },
  created () {
    this.friendlink()
    this.baseset()
  }
}
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    height: 358px;
    background: url('../assets/img/footer-bg.png') no-repeat center;
    background-size: cover;
    overflow: hidden;
    position: absolute;
    bottom:0;
    left: 0;
}
.footer-main {
    width: 1280px;
    height: 290px;
    margin: 68px auto 0;
    display: flex;
    line-height: 1;
    position: relative;
    .footer-main-left {
        width: 192px;
    }
    .footer-main-middle {
        width: 364px;
    }
    h6 {
        font-size: 18px;
        color: #d3d3d3;
        margin-bottom: 30px;
    }
    .about-us {
        font-size: 14px;
        color: #d3d3d3;
        margin-bottom: 21px;
        font-weight: bold;
        cursor: pointer;
        display: block;
        text-decoration: none;
    }
    .footer-main-right {
        flex: 1;
        display: flex;
        .phone-email {
            width: 230px;
            height: 158px;
            margin-top: 2px;
            border-left: 1px solid #676767;
            display: flex;
            align-items: center;
            flex-direction: column;
            p {
                text-align: center;
                line-height: 25px;
                color: #d3d3d3;
                font-weight: bold;
                margin-bottom: 20px;
            }
            a {
                color: #d3d3d3;
                font-size: 14px;
                text-decoration: none;
                width: 175px;
                height: 33px;
                display: flex;
                align-items: center;
                font-weight: bold;
                background: rgba($color: #ffffff, $alpha: 0.3);
                border-radius: 5px;
                margin-top: 10px;
            }
            svg {
                margin-left: 13px;
                margin-right: 12px;
            }
        }
        .qr-code {
            width: 490px;
            margin-top: 2px;
            ul {
                display: flex;
                justify-content: space-between;
                li {
                  width: 157px;
                  height: 157px;

                  .code-box{
                    width:100%;
                    height:100%;
                     background:#fff;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-bottom: 6px;
                    img{
                    // display: block;
                    width: 130px;
                    height: 130px;
                  }
                }

                }
                p {
                    color: #a6a6a6;
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                    font-weight: 400;
                }
            }
        }
    }
    .footer-address {
        position: absolute;
        left: 0;
        bottom: 26px;
        z-index: 1000;
        line-height: 1;
        font-size: 14px;
        color: #9f9f9f;
    }
    .footer-copyine {
        font-size: 12px;
        color: #9f9f9f;
        position: absolute;
        right: 0;
        bottom: 24px;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .copyine-link {
      color: #9f9f9f;
      margin-left: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue